/* AMP_EXACT_VEHICLE_ROUTES_V1: target-to-canonical structural routing */
const AMP_EXACT_VEHICLE_ROUTES={};
const AMP_EXACT_CATEGORY_ROUTES={};
const AMP_VEHICLE_REGISTRATION_KEY="amp_vehicle_registration_v1";
const AMP_MANUFACTURER_HANDLE_ALIASES=Object.freeze({
  "volkswagen":"vw",
  "volkswagen-vw":"vw",
  "vw-volkswagen":"vw",
  "volkswagen-cars":"vw",
  "mercedes":"mercedes-benz",
  "mercedes-benz-ag":"mercedes-benz",
  "mercedes-benz-cars":"mercedes-benz",
  "landrover":"land-rover",
  "land-rover-uk":"land-rover",
  "ds-automobiles":"ds",
  "great-wall-motors":"great-wall",
  "mg-motor":"mg",
  "mini-bmw":"mini",
  "rolls-royce-motor-cars":"rolls-royce",
  "skoda-auto":"skoda",
  "ssang-yong":"ssangyong"
});
function ampNormaliseManufacturerHandle(value){
  var handle=String(value||"").normalize("NFKD").replace(/[\u0300-\u036f]/g,"").trim().toLowerCase().replace(/&/g,"and").replace(/[^a-z0-9]+/g,"-").replace(/^-+|-+$/g,"");
  return AMP_MANUFACTURER_HANDLE_ALIASES[handle]||handle;
}
function ampCanonicalVehicleCollectionPath(pathname){
  var match=String(pathname||"").match(/^\/collections\/vl_([a-z0-9-]+)\/?$/i);
  if(!match)return "";
  var canonicalHandle=ampNormaliseManufacturerHandle(match[1]);
  return canonicalHandle&&canonicalHandle!==match[1].toLowerCase()?"/collections/vl_"+canonicalHandle:"";
}
function ampVehicleTargetFromCurrentUrl(){return new URLSearchParams(location.search).getAll("filter.v.m.car.ids").flatMap(function(value){return String(value||"").split(",");}).map(function(value){return value.trim();}).find(function(value){return /^\d+$/.test(value);})||"";}
function ampVehicleTargetsFromSavedState(){var ids=[];function add(value){String(value||"").split(",").map(function(item){return item.trim();}).forEach(function(item){if(/^\d+$/.test(item)&&ids.indexOf(item)===-1)ids.push(item);});}new URLSearchParams(location.search).getAll("filter.v.m.car.ids").forEach(add);try{var vehicle=JSON.parse(localStorage.getItem("vehicle")||"null");add(vehicle&&(vehicle.linkageTargetId||vehicle.engineId));}catch(error){}try{var filters=JSON.parse(localStorage.getItem("filterId")||"[]");if(Array.isArray(filters))filters.forEach(function(row){add(row&&row.selectEngineId);});}catch(error){}try{var cookie=(document.cookie||"").split(";").map(function(part){return part.trim();}).find(function(part){return part.indexOf("selectedVehicle=")===0;});if(cookie){var selected=JSON.parse(decodeURIComponent(cookie.slice("selectedVehicle=".length)));add(selected&&selected.engineId);}}catch(error){}try{var saved=JSON.parse(localStorage.getItem(AMP_VEHICLE_REGISTRATION_KEY)||"null");add(saved&&saved.targetId);}catch(error){}return ids;}
function ampRememberVehicleRegistration(vehicle){var targetId=String(vehicle&&(vehicle.linkageTargetId||vehicle.engineId)||"").trim(),registration=String(vehicle&&vehicle.registration||"").toUpperCase().replace(/[^A-Z0-9]/g,"");try{if(/^\d+$/.test(targetId)&&registration){localStorage.setItem(AMP_VEHICLE_REGISTRATION_KEY,JSON.stringify({targetId:targetId,registration:registration}));return;}var saved=JSON.parse(localStorage.getItem(AMP_VEHICLE_REGISTRATION_KEY)||"null");if(saved&&String(saved.targetId||"")!==targetId)localStorage.removeItem(AMP_VEHICLE_REGISTRATION_KEY);}catch(error){}}
function ampVehicleRegistrationForTarget(target){var targetId=String(target||"").trim();try{var saved=JSON.parse(localStorage.getItem(AMP_VEHICLE_REGISTRATION_KEY)||"null");return saved&&String(saved.targetId||"")===targetId?String(saved.registration||""):"";}catch(error){return "";}}
function ampFormatVehicleRegistration(value){var registration=String(value||"").toUpperCase().replace(/[^A-Z0-9]/g,"");return registration.length>3?registration.slice(0,-3)+" "+registration.slice(-3):registration;}
function ampVehiclePreservingClearUrl(){var targetId=ampVehicleTargetFromCurrentUrl(),url=new URL(location.href);Array.from(url.searchParams.keys()).forEach(function(key){if(key.indexOf("filter.")===0&&key!=="filter.v.m.car.ids")url.searchParams.delete(key);});if(targetId)url.searchParams.set("filter.v.m.car.ids",targetId);url.searchParams.delete("page");return url.pathname+(url.searchParams.toString()?"?"+url.searchParams.toString():"")+url.hash;}
function ampVehicleRemovalUrl(){var url=new URL(location.href);url.searchParams.delete("filter.v.m.car.ids");url.searchParams.delete("page");return url.pathname+(url.searchParams.toString()?"?"+url.searchParams.toString():"")+url.hash;}
function ampHasOtherShopifyFilters(){var hasOther=false;new URL(location.href).searchParams.forEach(function(value,key){if(key.indexOf("filter.")===0&&key!=="filter.v.m.car.ids"&&String(value||"").trim())hasOther=true;});return hasOther;}
function ampSyncPillAreaVehicleClearControls(){var targetId=ampVehicleTargetFromCurrentUrl();document.querySelectorAll("#CollectionActions .collection-actions-filters").forEach(function(actions){var control=actions.querySelector("[data-amp-vehicle-clear-control]");if(!targetId){var generated=control&&control.closest("[data-amp-client-clear-filters]");if(generated)generated.remove();return;}if(!control){var remove=document.createElement("facet-remove");remove.dataset.ampClientClearFilters="true";control=document.createElement("a");control.className="button-text-link button-clear-collection-filters";control.dataset.ampVehicleClearControl="true";remove.append(control);actions.append(remove);}if(ampHasOtherShopifyFilters()){if(control.textContent.trim()!=="Clear filters")control.textContent="Clear filters";control.setAttribute("aria-label","Clear filters");control.setAttribute("href",ampVehiclePreservingClearUrl());control.dataset.ampClearAllFilters="true";control.removeAttribute("data-amp-remove-vehicle-filter");}else{if(control.textContent.trim()!=="Change Vehicle")control.textContent="Change Vehicle";control.setAttribute("aria-label","Change Vehicle");control.setAttribute("href",ampVehicleRemovalUrl());control.dataset.ampRemoveVehicleFilter="true";control.removeAttribute("data-amp-clear-all-filters");}});}
var ampRegistrationChipDecorationScheduled=false;
function ampDecorateRegistrationVehicleChips(){ampRegistrationChipDecorationScheduled=false;var targetId=ampVehicleTargetFromCurrentUrl(),registration=ampFormatVehicleRegistration(ampVehicleRegistrationForTarget(targetId));if(!targetId||!registration)return;document.querySelectorAll('[data-amp-remove-vehicle-filter][data-amp-vehicle-filter-id="'+targetId+'"]' ).forEach(function(chip){var label=chip.querySelector("span:first-child"),ariaLabel="Remove vehicle filter "+registration;if(label&&label.textContent!==registration)label.textContent=registration;if(!chip.classList.contains("amp-registration-filter-chip"))chip.classList.add("amp-registration-filter-chip");if(chip.getAttribute("aria-label")!==ariaLabel)chip.setAttribute("aria-label",ariaLabel);});}
function ampScheduleRegistrationVehicleChipDecoration(){if(ampRegistrationChipDecorationScheduled)return;ampRegistrationChipDecorationScheduled=true;requestAnimationFrame(function(){ampDecorateRegistrationVehicleChips();ampSyncPillAreaVehicleClearControls();});}
function ampClearSelectedVehicle(options){var candidate=options&&options.destination,destination=typeof candidate==="string"||candidate instanceof URL?String(candidate):location.href;window.ampVehicleClearInProgress=true;try{localStorage.removeItem("vehicle");localStorage.removeItem("filterId");localStorage.removeItem(AMP_VEHICLE_REGISTRATION_KEY);}catch(error){}try{sessionStorage.removeItem("amp_registration_search_handoff_v1");}catch(error){}document.cookie="selectedVehicle=; Max-Age=0; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; SameSite=Lax";var url;try{url=new URL(destination,location.href);}catch(error){url=new URL(location.href);}url.searchParams.delete("filter.v.m.car.ids");url.searchParams.delete("page");location.assign(url.pathname+(url.searchParams.toString()?"?"+url.searchParams.toString():"")+url.hash);}
window.ampRememberVehicleRegistration=ampRememberVehicleRegistration;
window.ampVehicleRegistrationForTarget=ampVehicleRegistrationForTarget;
window.ampScheduleRegistrationVehicleChipDecoration=ampScheduleRegistrationVehicleChipDecoration;
window.ampSyncPillAreaVehicleClearControls=ampSyncPillAreaVehicleClearControls;
window.ampClearSelectedVehicle=ampClearSelectedVehicle;
window.ampVehicleTargetsFromSavedState=ampVehicleTargetsFromSavedState;
document.addEventListener("click",function(event){var control=event.target&&event.target.closest?event.target.closest("[data-amp-remove-vehicle-filter],[data-amp-clear-all-filters]"):null;if(!control)return;if(control.hasAttribute("data-amp-clear-all-filters")){if(!ampVehicleTargetFromCurrentUrl())return;control.setAttribute("href",ampVehiclePreservingClearUrl());return;}event.preventDefault();event.stopImmediatePropagation();ampClearSelectedVehicle({destination:control.getAttribute("href")||location.href});},true);
if(document.readyState==="loading")document.addEventListener("DOMContentLoaded",ampScheduleRegistrationVehicleChipDecoration,{once:true});else ampScheduleRegistrationVehicleChipDecoration();
window.addEventListener("pageshow",ampScheduleRegistrationVehicleChipDecoration);
window.addEventListener("popstate",ampScheduleRegistrationVehicleChipDecoration);
document.addEventListener("collection:product-filters",ampScheduleRegistrationVehicleChipDecoration);
if(ampVehicleTargetFromCurrentUrl())new MutationObserver(ampScheduleRegistrationVehicleChipDecoration).observe(document.documentElement,{childList:true,subtree:true});
const AMP_NON_FITMENT_COLLECTIONS=new Set(["p_screenwash","number-plates"]);
function ampIsNonFitmentCollection(pathname){var match=String(pathname||"").match(/^\/collections\/([a-z0-9_-]+)\/?$/i);return Boolean(match&&AMP_NON_FITMENT_COLLECTIONS.has(match[1].toLowerCase()));}
function ampExactVehicleRoute(target){return AMP_EXACT_VEHICLE_ROUTES[String(target||'').trim()]||'';}
function ampExactCategoryRoute(pathname,target){var match=String(pathname||'').match(/^\/collections\/(p_[a-z0-9_-]+)\/?$/);return match?AMP_EXACT_CATEGORY_ROUTES[match[1]+'::'+String(target||'').trim()]||'':'';}
(function(){var p=new URLSearchParams(location.search),target=p.get('filter.v.m.car.ids')||'',destination='',canonicalVehiclePath=ampCanonicalVehicleCollectionPath(location.pathname);if(canonicalVehiclePath){location.replace(canonicalVehiclePath+(p.toString()?'?'+p.toString():'')+location.hash);return;}if(target&&ampIsNonFitmentCollection(location.pathname)){p.delete('filter.v.m.car.ids');var cleanUrl=location.pathname+(p.toString()?'?'+p.toString():'')+location.hash;location.replace(cleanUrl);return;}if(/^\/collections\/vl_[a-z0-9-]+\/?$/.test(location.pathname))destination=ampExactVehicleRoute(target);else destination=ampExactCategoryRoute(location.pathname,target);if(destination)location.replace(destination);})();

document.addEventListener("DOMContentLoaded", () => {
  const tabs = document.querySelectorAll(".tab");
  const panels = {
    reg: document.getElementById("panel-reg"),
    model: document.getElementById("panel-model"),
  };
  const submitRegistrationBtn = document.getElementById("submit-registration");
  const submitModelBtn = document.getElementById("submit-model");
  const explorePartsBtn = document.getElementById("explore-parts");
  const regInput = document.querySelector('input[name="keySystemNumber"]');
  const changeVehicleBtn = document.getElementById("change-vehicle");
  const REG_API_URL =
    "https://plain-bonus-da6d.automotopartuk.workers.dev/TecdocToCatDLB.jsonEndpoint";
  const LOOKUP_ANALYTICS_URL =
    "https://plain-bonus-da6d.automotopartuk.workers.dev/analytics/vehicle-lookup-event";
  const lookupAnalyticsSources = new Set([
    "home",
    "collection",
    "vehicle_landing",
    "page",
    "search_page",
    "product_compatibility",
    "store_search_confirmation",
    "other",
  ]);
  const lookupAnalyticsMethods = new Set(["registration", "manual_dropdown"]);
  const lookupAnalyticsEvents = new Set([
    "manual_started",
    "manual_make_selected",
    "manual_model_selected",
    "manual_engine_selected",
    "manual_completed",
    "search_detected",
    "search_prompt_shown",
    "search_prompt_yes",
    "search_prompt_no",
    "registration_client_blocked",
    "registration_client_error",
  ]);
  const lookupAnalyticsDetails = new Set([
    "challenge_unavailable",
    "challenge_failed",
    "daily_cap",
    "local_rate_limit",
    "request_failed",
  ]);

  function lookupAnalyticsSourceFromPage() {
    const pathname = String(window.location.pathname || "")
      .replace(/\/+$/, "") || "/";
    if (pathname === "/") return "home";
    if (pathname === "/search") return "search_page";
    if (/^\/products\//.test(pathname)) return "product_compatibility";
    if (/^\/collections\/vl_[a-z0-9_-]+$/i.test(pathname)) {
      return "vehicle_landing";
    }
    if (/^\/collections\//.test(pathname)) return "collection";
    if (/^\/pages\/car-parts(?:\/|$)/i.test(pathname)) {
      return "vehicle_landing";
    }
    if (/^\/pages\//.test(pathname)) return "page";
    return "other";
  }

  function lookupAnalyticsSource(anchor, explicitSource) {
    const explicit = String(explicitSource || "").trim();
    if (lookupAnalyticsSources.has(explicit) && explicit !== "other") {
      return explicit;
    }
    const element = anchor instanceof Element ? anchor : null;
    const detected = String(
      element?.closest("[data-amp-lookup-source]")?.dataset?.ampLookupSource || ""
    ).trim();
    if (lookupAnalyticsSources.has(detected) && detected !== "other") {
      return detected;
    }
    return lookupAnalyticsSourceFromPage();
  }

  function lookupAnalyticsDetail(value) {
    const detail = String(value || "").trim();
    if (detail === "security_check_unavailable") return "challenge_unavailable";
    if (
      detail === "security_check_failed" ||
      detail === "security_check_expired" ||
      detail === "security_check_timeout"
    ) {
      return "challenge_failed";
    }
    if (detail === "rate_limit") return "local_rate_limit";
    return lookupAnalyticsDetails.has(detail) ? detail : "request_failed";
  }

  function trackLookupAnalytics(event, options = {}) {
    const safeEvent = String(event || "").trim();
    const safeMethod = String(options.method || "").trim();
    if (!lookupAnalyticsEvents.has(safeEvent) || !lookupAnalyticsMethods.has(safeMethod)) {
      return;
    }
    const payload = {
      event: safeEvent,
      source: lookupAnalyticsSource(options.anchor, options.source),
      method: safeMethod,
    };
    if (
      safeEvent === "registration_client_blocked" ||
      safeEvent === "registration_client_error"
    ) {
      payload.detail = lookupAnalyticsDetail(options.detail);
    }
    fetch(LOOKUP_ANALYTICS_URL, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
      keepalive: true,
    }).catch(() => {});
  }

  window.ampTrackVehicleLookupAnalytics = trackLookupAnalytics;

  const configHeaders = {
    "Content-Type": "application/json",
    "Access-Control-Allow-Headers": "Content-Type, Authorization",
  };
  const turnstileSiteKey = String(
    document.querySelector('meta[name="amp-turnstile-sitekey"]')?.content || ""
  ).trim();
  const turnstileApiUrl =
    "https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit";
  let turnstileApiPromise = null;

  function loadTurnstileApi() {
    if (window.turnstile?.render && window.turnstile?.execute) {
      return Promise.resolve(window.turnstile);
    }
    if (turnstileApiPromise) return turnstileApiPromise;

    turnstileApiPromise = new Promise((resolve, reject) => {
      let script = document.querySelector("script[data-amp-turnstile-loader]");
      const timer = window.setTimeout(() => {
        reject(new Error("turnstile_load_timeout"));
      }, 10000);
      const finish = () => {
        window.clearTimeout(timer);
        if (window.turnstile?.render && window.turnstile?.execute) {
          resolve(window.turnstile);
        } else {
          reject(new Error("turnstile_unavailable"));
        }
      };
      const fail = () => {
        window.clearTimeout(timer);
        script?.remove();
        reject(new Error("turnstile_load_failed"));
      };

      if (!script) {
        script = document.createElement("script");
        script.src = turnstileApiUrl;
        script.async = true;
        script.defer = true;
        script.dataset.ampTurnstileLoader = "1";
        document.head.appendChild(script);
      }
      script.addEventListener("load", finish, { once: true });
      script.addEventListener("error", fail, { once: true });
    }).catch((error) => {
      turnstileApiPromise = null;
      throw error;
    });

    return turnstileApiPromise;
  }

  function createTurnstileMount(challengeAnchor) {
    const shell = document.createElement("div");
    shell.className = "amp-turnstile-shell";
    shell.setAttribute("role", "group");
    shell.setAttribute("aria-label", "Security check");

    const widget = document.createElement("div");
    widget.className = "amp-turnstile-widget";
    const status = document.createElement("p");
    status.className = "amp-turnstile-status visually-hidden";
    status.setAttribute("role", "status");
    status.setAttribute("aria-live", "polite");
    status.textContent = "Checking browser security.";
    shell.append(widget, status);

    const anchor = challengeAnchor instanceof HTMLElement ? challengeAnchor : null;
    const placement =
      anchor?.closest(".amp-registration-search-actions") ||
      anchor?.closest("[data-product-compatibility-reg-form]") ||
      anchor?.closest(".reg-row") ||
      anchor?.parentElement;
    if (placement?.insertAdjacentElement) {
      placement.insertAdjacentElement("afterend", shell);
    } else {
      document.body.appendChild(shell);
    }
    return { shell, widget, status, anchor };
  }

  async function requestTurnstileToken(challengeAnchor) {
    if (!turnstileSiteKey) {
      return {
        ok: false,
        error: "security_check_unavailable",
        message: "The security check is temporarily unavailable. Please try again.",
      };
    }

    let turnstile;
    try {
      turnstile = await loadTurnstileApi();
    } catch (error) {
      return {
        ok: false,
        error: "security_check_unavailable",
        message:
          "We could not load the security check. Please check your connection or content blocker and try again.",
      };
    }

    const mount = createTurnstileMount(challengeAnchor);
    mount.anchor?.setAttribute("aria-busy", "true");

    return new Promise((resolve) => {
      let widgetId = null;
      let settled = false;
      const cleanup = () => {
        mount.anchor?.removeAttribute("aria-busy");
        if (widgetId !== null) {
          try {
            turnstile.remove(widgetId);
          } catch (error) {}
        }
        mount.shell.remove();
      };
      const fail = (error, message) => {
        if (settled) return;
        settled = true;
        cleanup();
        resolve({ ok: false, error, message });
      };

      try {
        widgetId = turnstile.render(mount.widget, {
          sitekey: turnstileSiteKey,
          action: "vehicle_lookup",
          execution: "execute",
          appearance: "interaction-only",
          theme: "auto",
          retry: "never",
          callback(token) {
            if (settled) return;
            const safeToken = String(token || "").trim();
            if (!safeToken) {
              fail(
                "security_check_failed",
                "The security check could not be verified. Please try again."
              );
              return;
            }
            settled = true;
            resolve({ ok: true, token: safeToken, cleanup });
          },
          "error-callback"() {
            fail(
              "security_check_failed",
              "The security check could not be completed. Please try again."
            );
          },
          "expired-callback"() {
            fail(
              "security_check_expired",
              "The security check expired. Please try again."
            );
          },
          "timeout-callback"() {
            fail(
              "security_check_timeout",
              "The security check timed out. Please try again."
            );
          },
        });
        turnstile.execute(widgetId);
      } catch (error) {
        fail(
          "security_check_unavailable",
          "The security check is temporarily unavailable. Please try again."
        );
      }
    });
  }

  const listMake = [];
  const listModel = [];
  const listEngine = [];
  const selectMake = document.getElementById("select-make");
  const selectModel = document.getElementById("select-model");
  const selectEngine = document.getElementById("select-engine");
  const fitmentContextElement = document.querySelector("[data-fitment-vehicle-key]");
  const fitmentVehicleKey = String(
    fitmentContextElement?.dataset?.fitmentVehicleKey || ""
  )
    .trim()
    .toLowerCase();
  const fitmentTokens = fitmentVehicleKey
    ? fitmentVehicleKey.split("--").filter(Boolean)
    : [];
  const fitmentJourney = {
    makeHandle: fitmentTokens[0] || "",
    modelFamilyHandle: fitmentTokens[1] || "",
    seriesHandle: fitmentTokens[2] || "",
    engineHandle: fitmentTokens[3] || "",
  };

  /******************************************************************
   * ✅ NO-DEV RATE LIMIT (per browser/device)
   * Limits PAID REG lookups only.
   * Default: 5 lookups per 10 minutes.
   ******************************************************************/
  function canRunRegLookup(limit, windowMs) {
    const key = "reg_lookup_timestamps_v1";
    const now = Date.now();

    let arr = [];
    try {
      arr = JSON.parse(localStorage.getItem(key) || "[]");
      if (!Array.isArray(arr)) arr = [];
    } catch (e) {
      arr = [];
    }

    arr = arr.filter((ts) => typeof ts === "number" && now - ts < windowMs);

    if (arr.length >= limit) {
      const waitMs = windowMs - (now - arr[0]);
      return { ok: false, waitMs };
    }

    arr.push(now);
    localStorage.setItem(key, JSON.stringify(arr));
    return { ok: true, waitMs: 0 };
  }

  function formatWait(waitMs) {
    const secs = Math.ceil(waitMs / 1000);
    if (secs <= 60) return `${secs}s`;
    const mins = Math.ceil(secs / 60);
    return `${mins} min`;
  }

  /******************************************************************
   * ✅ DAILY HARD CAP (per browser/device)
   * Max 10 PAID reg lookups per day
   ******************************************************************/
  function canRunDailyRegLookup(maxPerDay) {
    const key = "reg_lookup_daily_v1";
    const today = new Date().toISOString().slice(0, 10); // YYYY-MM-DD

    let data = {};
    try {
      data = JSON.parse(localStorage.getItem(key) || "{}");
    } catch (e) {
      data = {};
    }

    if (data.date !== today) {
      data = { date: today, count: 0 };
    }

    if (data.count >= maxPerDay) {
      return { ok: false, remaining: 0 };
    }

    data.count += 1;
    localStorage.setItem(key, JSON.stringify(data));

    return { ok: true, remaining: maxPerDay - data.count };
  }

  /******************************************************************
   * ✅ GA4 tracking (Google & YouTube Shopify app)
   ******************************************************************/
  function trackGA(eventName, params = {}) {
    if (typeof gtag === "function") {
      gtag("event", eventName, params);
    }
  }

  /**
   * ✅ Mecaparts trigger cookie
   * Mecaparts fitment block uses `selectedVehicle` cookie.
   * We set it whenever user selects vehicle by model/engine or by reg.
   */
  function setSelectedVehicleCookie(payload) {
    try {
      const value = encodeURIComponent(JSON.stringify(payload));
      document.cookie = `selectedVehicle=${value}; path=/; max-age=${60 * 60 * 24 * 30}`;
    } catch (e) {
      console.warn("Failed to set selectedVehicle cookie:", e);
    }
  }

  function normaliseHandleFromText(text) {
    return String(text || "")
      .trim()
      .toLowerCase()
      .replace(/&/g, "and")
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-+|-+$/g, "");
  }

  function humaniseFitmentHandle(handle) {
    return String(handle || "")
      .split("-")
      .filter(Boolean)
      .map((part) => {
        if (/\d/.test(part) || part.length <= 3) return part.toUpperCase();
        return part.charAt(0).toUpperCase() + part.slice(1);
      })
      .join(" ");
  }

  function findOptionByFitmentHandle(select, handle) {
    if (!select || !handle) return null;
    return (
      [...select.querySelectorAll("option")].find(
        (option) => option.dataset.fitmentHandle === handle
      ) || null
    );
  }

  function setSelectPrompt(select, text) {
    if (!select?.options?.length) return;
    select.options[0].textContent = text;
    select.value = "";
    updateNextSelectionCue();
  }

  function updateNextSelectionCue() {
    const selects = [selectMake, selectModel, selectEngine];
    selects.forEach((select) => select?.closest(".select")?.classList.remove("is-next-choice"));

    const makeSelected = Boolean(selectMake?.value);
    const modelSelected = Boolean(selectModel?.value);
    const engineSelected = Boolean(selectEngine?.value);
    const nextSelect = !makeSelected
      ? selectMake
      : !modelSelected
        ? selectModel
        : !engineSelected
          ? selectEngine
          : null;
    nextSelect?.closest(".select")?.classList.add("is-next-choice");
  }

  function getMakeNameFromSelect(makeId) {
    try {
      if (!selectMake) return "";
      const opt = [...selectMake.options].find((o) => o.value === makeId);
      return (opt?.textContent || "").trim();
    } catch {
      return "";
    }
  }

  function getModelTextFromSelect(modelId) {
    try {
      if (!selectModel) return "";
      const opt = [...selectModel.querySelectorAll("option")].find(
        (o) => o.value === modelId
      );
      return (opt?.textContent || "").trim();
    } catch {
      return "";
    }
  }

  function buildSelectedVehiclePayloadFromEngine(engineObj) {
    const makeId = selectMake?.value || "";
    const modelId = selectModel?.value || "";

    const manufacturerName =
      engineObj?.mfrName || getMakeNameFromSelect(makeId) || "";
    const manufacturerId = `vl_${ampNormaliseManufacturerHandle(manufacturerName)}`;

    const modelText = getModelTextFromSelect(modelId) || "";
    const engineText = (() => {
      if (!engineObj) return "";
      const hp = engineObj.horsePowerFrom ? `${engineObj.horsePowerFrom}CH` : "";
      const cc = engineObj.capacityCC ? `${engineObj.capacityCC}CC` : "";
      const desc = engineObj.description || "";
      const bits = [desc, hp, cc].filter(Boolean).join(", ");
      return bits || desc || "";
    })();

    return {
      vehicleType: "VL",
      manufacturer: manufacturerName,
      manufacturerId: manufacturerId,
      model: modelText,
      modelId: modelId ? String(modelId) : "",
      engine: engineText,
      engineId: engineObj?.linkageTargetId ? String(engineObj.linkageTargetId) : "",
    };
  }

  // Resolve the exact TecDoc target before persisting a registration result.
  // Registration data identifies the body style only (for example SUV), while
  // this target lookup supplies the exact model series and engine description.
  const exactVehicleTargetCache = new Map();

  async function fetchExactVehicleTarget(linkageTargetId) {
    const targetId = String(linkageTargetId || "").trim();
    if (!/^\d+$/.test(targetId)) return null;
    if (exactVehicleTargetCache.has(targetId)) {
      return exactVehicleTargetCache.get(targetId);
    }

    const requestPromise = (async () => {
      try {
        const response = await fetch(REG_API_URL, {
          method: "POST",
          headers: configHeaders,
          body: JSON.stringify({
            getLinkageTargets: {
              linkageTargetCountry: "gb",
              lang: "en",
              linkageTargetType: "P",
              linkageTargetIds: [{ id: Number(targetId), type: "P" }],
              perPage: 1,
              page: 1,
            },
          }),
        });
        if (!response.ok) return null;
        const data = await response.json();
        const exactTarget = Array.isArray(data?.linkageTargets)
          ? data.linkageTargets.find(
              (item) =>
                String(item?.linkageTargetId || "") === targetId &&
                String(item?.linkageTargetType || "P") === "P"
            )
          : null;
        return exactTarget || null;
      } catch (error) {
        console.warn("Exact vehicle identity lookup failed:", error);
        return null;
      }
    })();

    exactVehicleTargetCache.set(targetId, requestPromise);
    return requestPromise;
  }

  async function enrichVehicleIdentity(vehicle) {
    if (!vehicle?.linkageTargetId) return vehicle;
    if (
      vehicle?.linkageTargetType &&
      String(vehicle.linkageTargetType).toUpperCase() !== "P"
    ) {
      return vehicle;
    }
    if (vehicle?.vehicleModelSeriesName && vehicle?.vehicleDescription) return vehicle;

    const exactTarget = await fetchExactVehicleTarget(vehicle.linkageTargetId);
    if (!exactTarget) return vehicle;

    return {
      ...vehicle,
      mark: exactTarget.mfrName || vehicle.mark || "",
      mfrId: exactTarget.mfrId || vehicle.mfrId || "",
      vehicleModelSeriesName:
        exactTarget.vehicleModelSeriesName || vehicle.vehicleModelSeriesName || "",
      vehicleModelSeriesId:
        exactTarget.vehicleModelSeriesId || vehicle.vehicleModelSeriesId || "",
      vehicleDescription: exactTarget.description || vehicle.vehicleDescription || "",
      bodyTypeOfVehicle: exactTarget.bodyStyle || vehicle.bodyTypeOfVehicle || "",
      engineOutputInHP: exactTarget.capacityCC || vehicle.engineOutputInHP || "",
      engineCapacityCC: exactTarget.capacityCC || vehicle.engineCapacityCC || "",
      fuel: exactTarget.fuelType || vehicle.fuel || "",
      mfrYear:
        String(vehicle.mfrYear || "").slice(0, 4) ||
        String(exactTarget.beginYearMonth || "").slice(0, 4),
      linkageTargetId: exactTarget.linkageTargetId || vehicle.linkageTargetId,
    };
  }

  function formatFullVehicleName(vehicle) {
    const series = vehicle?.vehicleModelSeriesName || vehicle?.bodyTypeOfVehicle || "";
    const description = vehicle?.vehicleDescription || "";
    const capacity = vehicle?.engineCapacityCC || vehicle?.engineOutputInHP || "";
    return [
      vehicle?.mark || "",
      series,
      description && description !== series ? description : "",
      capacity ? `${capacity} cc` : "",
      vehicle?.fuel || "",
      String(vehicle?.mfrYear || "").slice(0, 4),
    ]
      .filter(Boolean)
      .join(" / ");
  }

  function buildSelectedVehiclePayloadFromStoredVehicle(vehicle) {
    const manufacturerName = vehicle?.mark || "";
    const manufacturerHandle = ampNormaliseManufacturerHandle(manufacturerName);
    const capacity = vehicle?.engineCapacityCC || vehicle?.engineOutputInHP || "";
    return {
      vehicleType: "VL",
      manufacturer: manufacturerName,
      manufacturerId: manufacturerHandle ? `vl_${manufacturerHandle}` : "",
      model: vehicle?.vehicleModelSeriesName || vehicle?.bodyTypeOfVehicle || "",
      modelId: vehicle?.vehicleModelSeriesId
        ? String(vehicle.vehicleModelSeriesId)
        : "",
      engine: [
        vehicle?.vehicleDescription || "",
        capacity ? `${capacity}CC` : "",
        vehicle?.fuel || "",
      ]
        .filter(Boolean)
        .join(", "),
      engineId: vehicle?.linkageTargetId ? String(vehicle.linkageTargetId) : "",
      registration: vehicle?.registration
        ? String(vehicle.registration).toUpperCase().replace(/[^A-Z0-9]/g, "")
        : "",
    };
  }

  function persistSelectedVehicle(vehicle) {
    if (!vehicle || window.ampVehicleClearInProgress) return;
    ampRememberVehicleRegistration(vehicle);
    localStorage.setItem("vehicle", JSON.stringify(vehicle));

    const targetId = String(vehicle?.linkageTargetId || "").trim();
    if (/^\d+$/.test(targetId)) {
      let storedRows = [];
      try {
        storedRows = JSON.parse(localStorage.getItem("filterId") || "[]");
      } catch (error) {
        storedRows = [];
      }
      if (!Array.isArray(storedRows)) storedRows = [];
      storedRows = storedRows.filter(
        (item) => String(item?.selectEngineId || "") !== targetId
      );
      storedRows.push({
        selectMakeId: String(vehicle?.mfrId || ""),
        selectModelId: String(vehicle?.vehicleModelSeriesId || ""),
        selectEngineId: targetId,
      });
      localStorage.setItem("filterId", JSON.stringify(storedRows));
      setSelectedVehicleCookie(buildSelectedVehiclePayloadFromStoredVehicle(vehicle));
    }

    const summary = document.getElementById("vehicle-name");
    if (summary) summary.textContent = formatFullVehicleName(vehicle);
    window.HENRY_SELECTED_VEHICLE_BAR_IMAGE_LOADER?.refresh?.();
    window.dispatchEvent(
      new CustomEvent("amp:vehicle-changed", {
        detail: { targetId: targetId },
      })
    );
  }

  const populateMakeSelect = () => {
    if (!selectMake || listMake.length === 0) return;
    while (selectMake.children.length > 1) {
      selectMake.removeChild(selectMake.lastChild);
    }

    const sortedMakes = listMake.sort((a, b) => {
      const nameA = a.name;
      const nameB = b.name;
      return nameA.localeCompare(nameB);
    });

    sortedMakes.forEach((make) => {
      const option = document.createElement("option");
      const makeName =
        make.name || make.mfrName || make.value || make.label || JSON.stringify(make);
      option.value = make.id || make.value || makeName;
      option.textContent = makeName;
      selectMake.appendChild(option);
    });
  };

  function convertYYMM(value) {
    if (value === null || value === undefined) return "";
    const str = String(value);
    if (!/^\d{6}$/.test(str)) return "";
    const year = str.slice(0, 4);
    const month = str.slice(4, 6);
    if (month < 1 || month > 12) return "";
    return `${month}/${year}`;
  }

  const populateModelSelect = () => {
    if (!selectModel || listModel.length === 0) return;
    while (selectModel.children.length > 1) {
      selectModel.removeChild(selectModel.lastChild);
    }
    const groupedModels = {};
    listModel.forEach((model) => {
      const modelName =
        model.name || model.modelName || model.value || model.label || JSON.stringify(model);
      let groupName = "";
      const nameWithoutParentheses = modelName.split(" ");
      groupName = nameWithoutParentheses[0];

      if (!groupedModels[groupName]) {
        groupedModels[groupName] = [];
      }
      groupedModels[groupName].push(model);
    });

    const sortedGroups = Object.keys(groupedModels).sort((a, b) => {
      const aIsNumber = /^\d+$/.test(a);
      const bIsNumber = /^\d+$/.test(b);
      if (aIsNumber && bIsNumber) return parseInt(a) - parseInt(b);
      if (aIsNumber) return -1;
      if (bIsNumber) return 1;
      return a.localeCompare(b);
    });

    sortedGroups.forEach((groupName) => {
      const optgroup = document.createElement("optgroup");
      optgroup.label = groupName;

      const sortedModels = groupedModels[groupName].sort((a, b) => {
        const nameA = a.name || a.modelName || a.value || a.label || "";
        const nameB = b.name || b.modelName || b.value || b.label || "";
        return nameA.localeCompare(nameB);
      });

      sortedModels.forEach((model) => {
        const option = document.createElement("option");
        const modelName =
          model.name || model.modelName || model.value || model.label || JSON.stringify(model);
        option.value = model.id || model.value || modelName;
        option.textContent = `${modelName} (${convertYYMM(model.beginYearMonth)} - ${convertYYMM(
          model.endYearMonth
        )})`;
        option.dataset.fitmentHandle = normaliseHandleFromText(modelName);
        optgroup.appendChild(option);
      });

      selectModel.appendChild(optgroup);
    });
  };

  function convertYYYYMM(value) {
    if (!value) return "";
    const str = String(value);
    if (!/^\d{4}-\d{2}$/.test(str)) return "";
    const [year, month] = str.split("-");
    if (month < 1 || month > 12) return "";
    return `${month}/${year}`;
  }

  const populateEngineSelect = () => {
    if (!selectEngine || listEngine.length === 0) return;
    while (selectEngine.children.length > 1) {
      selectEngine.removeChild(selectEngine.lastChild);
    }
    const groupedEngines = {};
    listEngine.forEach((engine) => {
      const fuelType = engine.fuelType || "Other";
      if (!groupedEngines[fuelType]) groupedEngines[fuelType] = [];
      groupedEngines[fuelType].push(engine);
    });
    const sortedGroups = Object.keys(groupedEngines).sort((a, b) => {
      return a.localeCompare(b);
    });
    sortedGroups.forEach((fuelType) => {
      const optgroup = document.createElement("optgroup");
      optgroup.label = fuelType;

      const sortedEngines = groupedEngines[fuelType].sort((a, b) => {
        const descA = (a.description || "").toLowerCase();
        const descB = (b.description || "").toLowerCase();
        const descCompare = descA.localeCompare(descB);
        if (descCompare !== 0) return descCompare;
        const hpA = a.horsePowerFrom || 0;
        const hpB = b.horsePowerFrom || 0;
        return hpA - hpB;
      });

      sortedEngines.forEach((engine) => {
        const option = document.createElement("option");
        const engineName = `${engine.description} (${engine.horsePowerFrom}CH), ${engine.capacityCC}CC - (${convertYYYYMM(
          engine.beginYearMonth
        )} - ${convertYYYYMM(engine.endYearMonth)})`;
        option.value = JSON.stringify(engine);
        option.textContent = engineName;
        option.dataset.fitmentHandle = normaliseHandleFromText(engine.description);
        option.dataset.fitmentLabel = engine.description || "";
        option.dataset.linkageTargetId = String(engine.linkageTargetId || "");
        optgroup.appendChild(option);
      });

      selectEngine.appendChild(optgroup);
    });
  };

  const fetchModelsByMake = async (selectedMakeId) => {
    if (!selectedMakeId || selectedMakeId === "Select Make") return;

    try {
      listModel.length = 0;
      if (selectModel) {
        while (selectModel.children.length > 1) {
          selectModel.removeChild(selectModel.lastChild);
        }
      }
      listEngine.length = 0;
      if (selectEngine) {
        while (selectEngine.children.length > 1) {
          selectEngine.removeChild(selectEngine.lastChild);
        }
      }

      const res = await fetch(REG_API_URL, {
        method: "POST",
        headers: configHeaders,
        body: JSON.stringify({
          getLinkageTargets: {
            linkageTargetCountry: "gb",
            lang: "en",
            linkageTargetType: "P",
            mfrIds: [selectedMakeId],
            includeVehicleModelSeriesFacets: true,
          },
        }),
      });

      if (!res.ok) throw new Error(`Request failed: ${res.status}`);

      const data = await res.json();
      if (data?.vehicleModelSeriesFacets?.counts) {
        listModel.push(...data.vehicleModelSeriesFacets.counts);
        populateModelSelect();
      }
    } catch (error) {
      console.error("Model lookup error:", error);
    }
  };

  const fetchEnginesByMakeAndModel = async (makeId, modelSeriesId) => {
    if (
      !makeId ||
      makeId === "Select Make" ||
      !modelSeriesId ||
      modelSeriesId === "Select Model"
    )
      return;

    try {
      listEngine.length = 0;
      if (selectEngine) {
        while (selectEngine.children.length > 1) {
          selectEngine.removeChild(selectEngine.lastChild);
        }
      }

      const res = await fetch(REG_API_URL, {
        method: "POST",
        headers: configHeaders,
        body: JSON.stringify({
          getLinkageTargets: {
            linkageTargetCountry: "gb",
            lang: "en",
            linkageTargetType: "P",
            mfrIds: [makeId],
            vehicleModelSeriesIds: [modelSeriesId],
          },
        }),
      });

      if (!res.ok) throw new Error(`Request failed: ${res.status}`);

      const data = await res.json();
      if (data?.linkageTargets) {
        listEngine.push(...data.linkageTargets);
        populateEngineSelect();

        const _datafilter = getDataFilterFromLocal();
        if (_datafilter) {
          const matchingEngine = listEngine.find(
            (item) => String(item?.linkageTargetId || "") === String(_datafilter.selectEngineId)
          );
          if (selectMake) selectMake.value = _datafilter.selectMakeId;
          if (selectModel) selectModel.value = _datafilter.selectModelId;
          if (selectEngine && matchingEngine) {
            selectEngine.value = JSON.stringify(matchingEngine);
          }
        }
      }
    } catch (error) {
      console.error("Engine lookup error:", error);
    }
  };

  const preselectVehicleFromFitmentJourney = async () => {
    if (!fitmentJourney.makeHandle || !selectMake) return;

    const makeOption = [...selectMake.options].find(
      (option) => ampNormaliseManufacturerHandle(option.textContent) === ampNormaliseManufacturerHandle(fitmentJourney.makeHandle)
    );
    if (!makeOption) return;

    if (window.ampVehicleClearInProgress) return false;
    selectMake.value = makeOption.value;
    await fetchModelsByMake(makeOption.value);

    // A model-family page still offers the complete model/body list. Keep
    // the native prompt instead of presenting the family as a selection.
    if (!fitmentJourney.seriesHandle) return;

    const modelOption = findOptionByFitmentHandle(
      selectModel,
      fitmentJourney.seriesHandle
    );
    // If the exact series is absent, leave the native Select Model prompt.
    if (!modelOption) return;

    selectModel.value = modelOption.value;
    await fetchEnginesByMakeAndModel(makeOption.value, modelOption.value);
    if (!fitmentJourney.engineHandle) return;

    const matchingEngines = [...selectEngine.querySelectorAll("option")].filter(
      (option) => option.dataset.fitmentHandle === fitmentJourney.engineHandle
    );

    if (matchingEngines.length === 1) {
      selectEngine.value = matchingEngines[0].value;
      return;
    }

    const engineLabel =
      matchingEngines[0]?.dataset?.fitmentLabel ||
      humaniseFitmentHandle(fitmentJourney.engineHandle);
    setSelectPrompt(selectEngine, `${engineLabel} — Select exact engine`);
  };


  // amp-filtered-selector-hydration-v1
  // A filtered make-collection URL is authoritative even in a browser that
  // did not perform the original vehicle lookup. Resolve the exact TecDoc
  // target, populate the native selects, and persist the same selected state.
  const hydrateVehicleSelectorFromActiveFilter = async (activeFilterId) => {
    if (!/^\d+$/.test(String(activeFilterId || "")) || !selectMake || !selectModel || !selectEngine) {
      return false;
    }

    const makePathMatch = window.location.pathname.match(/^\/collections\/vl_([a-z0-9-]+)\/?$/);
    const makeHandle = makePathMatch?.[1] || "";
    if (!makeHandle) return false;

    const makeOption = [...selectMake.options].find(
      (option) => ampNormaliseManufacturerHandle(option.textContent) === ampNormaliseManufacturerHandle(makeHandle)
    );
    if (!makeOption) return false;

    let seriesOffset = 0;
    let resolvedModel = null;
    for (let requestIndex = 0; requestIndex < 12 && !resolvedModel; requestIndex += 1) {
      const response = await fetch(REG_API_URL, {
        method: "POST",
        headers: configHeaders,
        body: JSON.stringify({
          resolveCompatibleVehiclesTree: {
            linkageTargetCountry: "gb",
            lang: "en",
            linkageTargetType: "P",
            mfrId: makeOption.value,
            mfrName: makeOption.textContent.trim(),
            linkageTargetIds: [Number(activeFilterId)],
            seriesOffset,
            maxSeriesPerCall: 40,
          },
        }),
      });
      if (!response.ok) return false;
      const data = await response.json();
      const models = data?.categories?.[0]?.models || [];
      resolvedModel = models.find((model) =>
        (model.vehicles || []).some(
          (vehicle) => String(vehicle?.linkageTargetId || "") === String(activeFilterId)
        )
      ) || null;
      if (resolvedModel || data?.nextSeriesOffset == null) break;
      seriesOffset = Number(data.nextSeriesOffset);
    }
    if (!resolvedModel?.vehicleModelSeriesId) return false;

    selectMake.value = makeOption.value;
    await fetchModelsByMake(makeOption.value);
    const modelOption = [...selectModel.querySelectorAll("option")].find(
      (option) => String(option.value) === String(resolvedModel.vehicleModelSeriesId)
    );
    if (!modelOption) return false;

    selectModel.value = modelOption.value;
    await fetchEnginesByMakeAndModel(makeOption.value, modelOption.value);
    const engineOption = [...selectEngine.querySelectorAll("option")].find(
      (option) => String(option.dataset.linkageTargetId || "") === String(activeFilterId)
    );
    if (!engineOption?.value) return false;

    if (window.ampVehicleClearInProgress) return false;
    selectEngine.value = engineOption.value;
    const selectedEngine = JSON.parse(engineOption.value);
    const vehicle = {
      mark: selectedEngine.mfrName || makeOption.textContent.trim(),
      bodyTypeOfVehicle: [selectedEngine.vehicleModelSeriesName || resolvedModel.modelTitle || "", selectedEngine.description || ""].filter(Boolean).join(" / ") || selectedEngine.bodyStyle || "",
      engineOutputInHP: selectedEngine.capacityCC || "",
      engineCapacityCC: selectedEngine.capacityCC || "",
      fuel: selectedEngine.fuelType || "",
      mfrYear: String(selectedEngine.beginYearMonth || "").slice(0, 4),
      linkageTargetId: selectedEngine.linkageTargetId || activeFilterId,
    };

    localStorage.setItem("vehicle", JSON.stringify(vehicle));
    let storedFilterIds = [];
    try {
      storedFilterIds = JSON.parse(localStorage.getItem("filterId") || "[]");
      if (!Array.isArray(storedFilterIds)) storedFilterIds = [];
    } catch (error) {
      storedFilterIds = [];
    }
    storedFilterIds = storedFilterIds.filter(
      (item) => String(item?.selectEngineId || "") !== String(activeFilterId)
    );
    storedFilterIds.push({
      selectMakeId: makeOption.value,
      selectModelId: modelOption.value,
      selectEngineId: String(activeFilterId),
    });
    localStorage.setItem("filterId", JSON.stringify(storedFilterIds));

    setSelectedVehicleCookie(buildSelectedVehiclePayloadFromEngine(selectedEngine));
    const vehicleName = document.getElementById("vehicle-name");
    if (vehicleName) {
      vehicleName.textContent = [
        vehicle.mark,
        resolvedModel.modelTitle || vehicle.bodyTypeOfVehicle,
        selectedEngine.description || "",
        vehicle.engineCapacityCC ? `${vehicle.engineCapacityCC} cc` : "",
        vehicle.fuel,
        vehicle.mfrYear,
      ].filter(Boolean).join(" / ");
    }
    document.querySelector(".tab-query")?.classList.add("hidden");
    document.querySelector("#panel-reg-parts")?.classList.add("hidden");
    document.querySelector(".tab-vehicle-info")?.classList.remove("hidden");
    document.querySelector(".tab-vehicle-info-parts")?.classList.remove("hidden");
    if (regInput) regInput.value = "";
    updateNextSelectionCue();
    return true;
  };

  const getDataFilterFromLocal = () => {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const filterid = String(urlParams.get("filter.v.m.car.ids") || "").trim();
    if (!filterid) return null;

    let listFilterIds = [];
    try {
      listFilterIds = JSON.parse(localStorage.getItem("filterId") || "[]");
    } catch (error) {
      listFilterIds = [];
    }

    if (!Array.isArray(listFilterIds)) return null;
    return (
      [...listFilterIds]
        .reverse()
        .find((item) => String(item?.selectEngineId || "") === filterid) || null
    );
  };

  const initializeVehicleSelector = async () => {
    try {
      const activeFilterId = String(
        new URLSearchParams(window.location.search).get("filter.v.m.car.ids") || ""
      ).trim();
      const vehicle = localStorage.getItem("vehicle");
      if (vehicle) {
        let vehicleData = JSON.parse(vehicle);
        const storedFilterId = String(vehicleData?.linkageTargetId || "").trim();
        const vehicleMatchesUrl = !activeFilterId || storedFilterId === activeFilterId;

        if (vehicleMatchesUrl) {
          vehicleData = await enrichVehicleIdentity(vehicleData);
          persistSelectedVehicle(vehicleData);
          document.querySelector(".tab-query")?.classList.add("hidden");
          document.querySelector("#panel-reg-parts")?.classList.add("hidden");
          document.querySelector(".tab-vehicle-info")?.classList.remove("hidden");
          document.querySelector(".tab-vehicle-info-parts")?.classList.remove("hidden");
          if (regInput) regInput.value = "";
        } else {
          localStorage.removeItem("vehicle");
          localStorage.removeItem(AMP_VEHICLE_REGISTRATION_KEY);
          document.cookie = "selectedVehicle=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT";
        }
      }

      const res = await fetch(REG_API_URL, {
        method: "POST",
        headers: configHeaders,
        body: JSON.stringify({
          getLinkageTargets: {
            linkageTargetCountry: "gb",
            lang: "en",
            linkageTargetType: "P",
            includeMfrFacets: true,
          },
        }),
      });
      if (!res.ok) throw new Error(`Request failed: ${res.status}`);
      const data = await res.json();
      if (data?.mfrFacets?.counts) {
        listMake.push(...data?.mfrFacets?.counts);
        populateMakeSelect();
      }
      const _datafilter = getDataFilterFromLocal();
      if (_datafilter) {
        await fetchModelsByMake(_datafilter?.selectMakeId);
        await fetchEnginesByMakeAndModel(
          _datafilter?.selectMakeId,
          _datafilter?.selectModelId
        );
      } else {
        const restoredFromActiveFilter = activeFilterId
          ? await hydrateVehicleSelectorFromActiveFilter(activeFilterId)
          : false;
        if (!restoredFromActiveFilter) {
          await preselectVehicleFromFitmentJourney();
        }
      }
      updateNextSelectionCue();
    } catch (error) {
      console.error("Registration lookup error:", error);
    }
  };

  let vehicleSelectorInitializationPromise = null;
  const ensureVehicleSelectorInitialized = () => {
    if (!vehicleSelectorInitializationPromise) {
      vehicleSelectorInitializationPromise = initializeVehicleSelector();
    }
    return vehicleSelectorInitializationPromise;
  };

  if (selectMake && selectModel && selectEngine) {
    const isProductCompatibilitySelector = Boolean(
      selectMake.closest("[data-product-compatibility-selector]")
    );
    const hasActiveVehicleFilter = /^\d+$/.test(
      String(
        new URLSearchParams(window.location.search).get("filter.v.m.car.ids") || "",
      ).trim(),
    );
    let hasStoredVehicle = false;
    try {
      hasStoredVehicle = Boolean(
        localStorage.getItem("vehicle") || getDataFilterFromLocal(),
      );
    } catch (error) {
      hasStoredVehicle = false;
    }

    const needsImmediateInitialization = Boolean(
      !isProductCompatibilitySelector &&
        (hasActiveVehicleFilter || hasStoredVehicle || fitmentJourney.makeHandle),
    );

    if (needsImmediateInitialization) {
      ensureVehicleSelectorInitialized();
    } else {
      const initializationControls = [
        selectMake,
        selectModel,
        selectEngine,
        document.querySelector('.tab[data-tab="model"]'),
      ].filter(Boolean);
      const initializeOnInteraction = () => {
        initializationControls.forEach((control) => {
          control.removeEventListener("pointerdown", initializeOnInteraction);
          control.removeEventListener("focusin", initializeOnInteraction);
        });
        ensureVehicleSelectorInitialized();
      };

      initializationControls.forEach((control) => {
        control.addEventListener("pointerdown", initializeOnInteraction, {
          once: true,
          passive: true,
        });
        control.addEventListener("focusin", initializeOnInteraction, { once: true });
      });
    }
  }

  if (selectMake) {
    selectMake.addEventListener("change", (e) => {
      const selectedMakeId = e.target.value;
      if (selectedMakeId) {
        trackLookupAnalytics("manual_make_selected", {
          method: "manual_dropdown",
          anchor: selectMake,
        });
      }
      setSelectPrompt(selectModel, "Select Model");
      setSelectPrompt(selectEngine, "Select Engine");
      fetchModelsByMake(selectedMakeId).finally(updateNextSelectionCue);
      updateNextSelectionCue();
    });
  }

  if (selectModel) {
    selectModel.addEventListener("change", (e) => {
      const selectedModelId = e.target.value;
      if (selectedModelId) {
        trackLookupAnalytics("manual_model_selected", {
          method: "manual_dropdown",
          anchor: selectModel,
        });
      }
      const selectedMakeId = selectMake?.value;
      setSelectPrompt(selectEngine, "Select Engine");
      fetchEnginesByMakeAndModel(selectedMakeId, selectedModelId).finally(updateNextSelectionCue);
      updateNextSelectionCue();
    });
  }


  // amp-vehicle-submit-navigation-v1
  // Selecting an engine only prepares the vehicle. The customer decides when
  // to navigate by pressing the native Find Parts button.
  const navigateAfterVehicleSubmit = (vehicle) => {
    const targetId = String(vehicle?.linkageTargetId || "").trim();
    if (!/^\d+$/.test(targetId)) return false;

    const currentUrl = new URL(window.location.href);
    if (/\/products\//.test(currentUrl.pathname)) return true;

    const currentCollection = currentUrl.pathname.match(/^\/collections\/([a-z0-9_-]+)\/?$/i);
    const isPartCollection = Boolean(currentCollection && /^p_/i.test(currentCollection[1]));

    if (isPartCollection) {
      if (ampIsNonFitmentCollection(currentUrl.pathname)) {
        currentUrl.searchParams.delete("filter.v.m.car.ids");
        window.location.assign(currentUrl.toString());
        return true;
      }
      const exactCategoryDestination = ampExactCategoryRoute(currentUrl.pathname, targetId);
      if (exactCategoryDestination) {
        window.location.assign(exactCategoryDestination);
        return true;
      }
      currentUrl.searchParams.set("filter.v.m.car.ids", targetId);
      window.location.assign(currentUrl.toString());
      return true;
    }

    const manufacturerHandle = ampNormaliseManufacturerHandle(vehicle?.mark || "");
    if (!manufacturerHandle) return false;
    const exactVehicleDestination = ampExactVehicleRoute(targetId);
    const destination = exactVehicleDestination ||
      `/collections/vl_${manufacturerHandle}?filter.v.m.car.ids=${encodeURIComponent(targetId)}`;
    window.location.assign(destination);
    return true;
  };

  if (selectEngine) {
    selectEngine.addEventListener("change", (e) => {
      const selectEngineObj = JSON.parse(e?.target?.value || "{}");
      updateNextSelectionCue();

      if (selectEngineObj?.linkageTargetId) {
        trackLookupAnalytics("manual_engine_selected", {
          method: "manual_dropdown",
          anchor: selectEngine,
        });
        const payload = buildSelectedVehiclePayloadFromEngine(selectEngineObj);
        setSelectedVehicleCookie(payload);
      }

      // Navigation intentionally waits for the customer to press Find Parts.

      const selectMakeId = selectMake?.value;
      const selectModelId = selectModel?.value;
      const listDataLocal = JSON.parse(localStorage.getItem("filterId") || "[]");
      localStorage.setItem(
        "filterId",
        JSON.stringify([
          ...listDataLocal,
          { selectMakeId, selectModelId, selectEngineId: selectEngineObj?.linkageTargetId },
        ])
      );
    });
  }

  tabs.forEach((tab) => {
    tab.addEventListener("click", () => {
      tabs.forEach((t) => t.classList.remove("active"));
      tab.classList.add("active");
      const target = tab.dataset.tab;
      if (target === "model") {
        trackLookupAnalytics("manual_started", {
          method: "manual_dropdown",
          anchor: tab,
        });
      }

      Object.keys(panels).forEach((key) => {
        panels[key].classList.toggle("hidden", key !== target);
      });
    });
  });

  const openManualVehicleSelector = (message) => {
    const queryCard = document.querySelector(".tab-query");
    const modelTab = queryCard?.querySelector('.tab[data-tab="model"]');
    const modelPanel = panels.model;
    if (!queryCard || !modelTab || !modelPanel) return false;

    modelTab.click();
    ensureVehicleSelectorInitialized();

    let notice = modelPanel.querySelector(".amp-registration-fallback-message");
    if (!notice) {
      notice = document.createElement("p");
      notice.className = "helper amp-registration-fallback-message";
      notice.setAttribute("role", "status");
      modelPanel.prepend(notice);
    }
    notice.textContent =
      message ||
      "Registration lookup is temporarily unavailable. Please select your vehicle by make and model.";

    queryCard.scrollIntoView({ behavior: "smooth", block: "center" });
    return true;
  };

  window.ampOpenManualVehicleSelector = openManualVehicleSelector;

  if (changeVehicleBtn) {
    changeVehicleBtn.addEventListener("click", (e) => {
      e.preventDefault();

      const params = new URLSearchParams(window.location.search);
      if (
        params.has("filter.v.m.car.ids") &&
        typeof window.ampClearSelectedVehicle === "function"
      ) {
        window.ampClearSelectedVehicle({ destination: window.location.href });
        return;
      }

      localStorage.removeItem("vehicle");
      localStorage.removeItem("filterId");
      localStorage.removeItem(AMP_VEHICLE_REGISTRATION_KEY);
      document.cookie = "selectedVehicle=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT";

      document.querySelector(".tab-vehicle-info")?.classList.add("hidden");
      document.querySelector(".tab-vehicle-info-parts")?.classList.add("hidden");
      document.querySelector(".tab-query")?.classList.remove("hidden");
      document.querySelector("#panel-reg-parts")?.classList.remove("hidden");

      if (!location.pathname.startsWith("/collections")) return;

      if (params.has("filter.v.m.car.ids")) {
        params.delete("filter.v.m.car.ids");
        if (typeof FacetFiltersForm !== "undefined") {
          FacetFiltersForm.renderPage(params.toString(), null, true);
        }
      }
    });
  }

  if (explorePartsBtn) {
    explorePartsBtn.addEventListener("click", async () => {
      let vehicle = JSON.parse(localStorage.getItem("vehicle"));
      vehicle = await enrichVehicleIdentity(vehicle);
      persistSelectedVehicle(vehicle);
      const manufacturerHandle = ampNormaliseManufacturerHandle(vehicle?.mark || "");
      const manufacturerId = manufacturerHandle ? `vl_${manufacturerHandle}` : "";

      if (manufacturerId && vehicle?.linkageTargetId) {
        const exactDestination = ampExactVehicleRoute(vehicle.linkageTargetId);
        window.location.href = exactDestination || `/collections/${manufacturerId}?filter.v.m.car.ids=${encodeURIComponent(
          vehicle.linkageTargetId
        )}`;
      } else {
        window.location.href = "/pages/car-parts";
      }
    });
  }

  if (submitModelBtn) {
    submitModelBtn.addEventListener("click", (event) => {
      event.preventDefault();
      const selectedEngine = JSON.parse(selectEngine?.value || "{}");
      if (!selectedEngine?.linkageTargetId) return;

      if (selectedEngine?.linkageTargetId) {
        const payload = buildSelectedVehiclePayloadFromEngine(selectedEngine);
        setSelectedVehicleCookie(payload);
      }

      const vehicle = {
        mark: selectedEngine.mfrName,
        mfrId: selectedEngine.mfrId || "",
        vehicleModelSeriesName: selectedEngine.vehicleModelSeriesName || "",
        vehicleModelSeriesId: selectedEngine.vehicleModelSeriesId || "",
        vehicleDescription: selectedEngine.description || "",
        bodyTypeOfVehicle: selectedEngine.bodyStyle,
        engineOutputInHP: selectedEngine.capacityCC,
        engineCapacityCC: selectedEngine.capacityCC,
        fuel: selectedEngine.fuelType,
        mfrYear: `${selectedEngine.beginYearMonth.slice(0, 4)}`,
        linkageTargetId: selectedEngine.linkageTargetId,
      };
      if (submitModelBtn.dataset.ampAnalyticsCompleted !== "1") {
        submitModelBtn.dataset.ampAnalyticsCompleted = "1";
        trackLookupAnalytics("manual_completed", {
          method: "manual_dropdown",
          anchor: submitModelBtn,
        });
      }
      persistSelectedVehicle(vehicle);
      document.querySelector(".tab-query")?.classList.add("hidden");
      document.querySelector("#panel-reg-parts")?.classList.add("hidden");
      document.querySelector(".tab-vehicle-info")?.classList.remove("hidden");
      document.querySelector(".tab-vehicle-info-parts")?.classList.remove("hidden");
      navigateAfterVehicleSubmit(vehicle);
    });
  }

  const registrationLookupsInFlight = new Map();

  async function runRegistrationLookup(rawRegistration, options = {}) {
    const registration = String(rawRegistration || "")
      .toUpperCase()
      .replace(/[^A-Z0-9]/g, "");
    if (!registration) {
      return {
        ok: false,
        error: "missing_registration",
        message: "Enter your vehicle registration.",
      };
    }

    // One customer confirmation must create at most one paid plate request,
    // including rapid double-clicks from either the lookup form or search dialog.
    if (registrationLookupsInFlight.has(registration)) {
      return registrationLookupsInFlight.get(registration);
    }

    const lookupPromise = (async () => {
      const analyticsSource = lookupAnalyticsSource(
        options.challengeAnchor,
        options.analyticsSource
      );
      trackGA("reg_lookup_click", { lookup_type: "registration" });

      const challenge = await requestTurnstileToken(
        options.challengeAnchor ||
          (document.activeElement instanceof HTMLElement
            ? document.activeElement
            : submitRegistrationBtn)
      );
      if (!challenge.ok) {
        trackLookupAnalytics("registration_client_blocked", {
          method: "registration",
          source: analyticsSource,
          detail: challenge.error,
        });
        trackGA("reg_lookup_blocked", {
          lookup_type: "registration",
          reason: challenge.error,
        });
        return challenge;
      }

      try {
        // Only consume the browser-side counters after the security check has
        // completed. Failed or blocked challenges must never use lookup quota.
        const daily = canRunDailyRegLookup(10);
        if (!daily.ok) {
          trackLookupAnalytics("registration_client_blocked", {
            method: "registration",
            source: analyticsSource,
            detail: "daily_cap",
          });
          trackGA("reg_lookup_blocked", {
            lookup_type: "registration",
            reason: "daily_cap",
          });
          return {
            ok: false,
            error: "daily_cap",
            message:
              "You have reached the daily limit for vehicle lookups. Please try again tomorrow.",
          };
        }

        const rateLimit = canRunRegLookup(5, 10 * 60 * 1000);
        if (!rateLimit.ok) {
          trackLookupAnalytics("registration_client_blocked", {
            method: "registration",
            source: analyticsSource,
            detail: "local_rate_limit",
          });
          trackGA("reg_lookup_blocked", {
            lookup_type: "registration",
            reason: "rate_limit",
            wait_seconds: Math.ceil(rateLimit.waitMs / 1000),
          });
          return {
            ok: false,
            error: "rate_limit",
            message: `Too many lookups. Please wait ${formatWait(rateLimit.waitMs)} and try again.`,
          };
        }

        const response = await fetch(REG_API_URL, {
          method: "POST",
          headers: configHeaders,
          body: JSON.stringify({
            getVehiclesByKeyNumberPlates: {
              country: "gb",
              keySystemNumber: registration,
              keySystemType: 99,
              lang: "en",
              details: true,
              turnstileToken: challenge.token,
              analyticsSource,
            },
          }),
        });

        const data = await response.json().catch(() => null);
        if (!response.ok) {
          const statusText = String(data?.statusText || "").trim();
          if (response.status === 403) {
            return {
              ok: false,
              error: String(data?.error || "security_check_failed"),
              message:
                statusText ||
                "The security check could not be verified. Please try again.",
            };
          }
          if (response.status === 429) {
            return {
              ok: false,
              error: "rate_limit",
              message: statusText || "Too many lookups. Please wait and try again.",
            };
          }
          if (response.status === 503 && data?.error === "challenge_unavailable") {
            return {
              ok: false,
              error: "security_check_unavailable",
              message:
                statusText ||
                "The security check is temporarily unavailable. Please try again.",
            };
          }
          if ([502, 503, 504].includes(response.status)) {
            return {
              ok: false,
              error: "supplier_unavailable",
              message:
                "Registration lookup is temporarily unavailable. Please select your vehicle by make and model.",
            };
          }
          throw new Error(`Request failed: ${response.status}`);
        }

        if (!data || typeof data !== "object") {
          throw new Error("Invalid registration lookup response");
        }
        const firstMatch = data?.data?.array?.[0];
        const vehicleDetails = firstMatch?.vehicleDetails;
        if (!vehicleDetails) {
          if (data?.meta?.vehicleFound && data?.meta?.fitmentMapped === false) {
            return {
              ok: false,
              error: "fitment_mapping_unavailable",
              message:
                "We found that vehicle, but the supplier has not linked it to a TecDoc fitment yet. Please select your vehicle manually or contact us for help.",
            };
          }
          return {
            ok: false,
            error: "no_match",
            message: "We could not find that registration. Check it and try again.",
          };
        }

        trackGA("reg_lookup_success", { lookup_type: "registration" });

        let vehicle = {
          ...vehicleDetails,
          registration,
          linkageTargetId:
            vehicleDetails.linkageTargetId || firstMatch?.carId,
        };
        vehicle = await enrichVehicleIdentity(vehicle);
        persistSelectedVehicle(vehicle);
        document.querySelector(".tab-query")?.classList.add("hidden");
        document.querySelector("#panel-reg-parts")?.classList.add("hidden");
        document.querySelector(".tab-vehicle-info")?.classList.remove("hidden");
        document.querySelector(".tab-vehicle-info-parts")?.classList.remove("hidden");
        if (regInput) regInput.value = "";

        const navigated =
          options.navigate === false ? false : navigateAfterVehicleSubmit(vehicle);
        return { ok: true, vehicle, navigated };
      } catch (error) {
        trackLookupAnalytics("registration_client_error", {
          method: "registration",
          source: analyticsSource,
          detail: "request_failed",
        });
        trackGA("reg_lookup_error", {
          lookup_type: "registration",
          message: error?.message || "unknown",
        });
        console.error("Registration lookup error:", error);
        return {
          ok: false,
          error: "request_failed",
          message:
            "Registration lookup is temporarily unavailable. Please select your vehicle by make and model.",
        };
      } finally {
        challenge.cleanup?.();
      }
    })();

    registrationLookupsInFlight.set(registration, lookupPromise);
    try {
      return await lookupPromise;
    } finally {
      registrationLookupsInFlight.delete(registration);
    }
  }

  window.ampRunRegistrationLookup = runRegistrationLookup;

  if (submitRegistrationBtn && regInput) {
    submitRegistrationBtn.addEventListener("click", async (event) => {
      event.preventDefault();

      const registration = regInput.value.trim();
      if (!registration) {
        regInput.setCustomValidity("Enter your vehicle registration.");
        regInput.reportValidity();
        regInput.addEventListener(
          "input",
          () => regInput.setCustomValidity(""),
          { once: true }
        );
        return;
      }
      regInput.setCustomValidity("");

      if (submitRegistrationBtn.dataset.loading === "1") return;
      submitRegistrationBtn.dataset.loading = "1";
      submitRegistrationBtn.disabled = true;
      const result = await runRegistrationLookup(registration, {
        challengeAnchor: submitRegistrationBtn,
      });
      if (!result.ok && result.message) {
        const manualFallbackOpened =
          (result.error === "supplier_unavailable" || result.error === "request_failed") &&
          openManualVehicleSelector(result.message);
        if (!manualFallbackOpened) alert(result.message);
      }
      submitRegistrationBtn.dataset.loading = "0";
      submitRegistrationBtn.disabled = false;
    });
  }

  const selectsToggle = document.getElementById("selects-toggle");
  const selectsAccordion = document.querySelector(".selects-accordion");

  if (selectsToggle && selectsAccordion) {
    selectsToggle.addEventListener("click", () => {
      selectsAccordion.classList.toggle("expanded");
      if (selectsAccordion.classList.contains("expanded")) {
        trackLookupAnalytics("manual_started", {
          method: "manual_dropdown",
          anchor: selectsToggle,
        });
      }
    });
  }

  const closeBtn = document.getElementById("icon-close-filter-svg");

  if (closeBtn) {
    closeBtn.addEventListener("click", (e) => {
      e.preventDefault();

      if (selectMake) selectMake.selectedIndex = 0;
      if (selectModel) selectModel.selectedIndex = 0;
      if (selectEngine) selectEngine.selectedIndex = 0;
      setSelectPrompt(selectModel, "Select Model");
      setSelectPrompt(selectEngine, "Select Engine");

      listModel.length = 0;
      listEngine.length = 0;

      if (selectModel) {
        while (selectModel.children.length > 1) selectModel.removeChild(selectModel.lastChild);
      }
      if (selectEngine) {
        while (selectEngine.children.length > 1) selectEngine.removeChild(selectEngine.lastChild);
      }

      localStorage.removeItem("filterId");
      localStorage.removeItem("vehicle");
      localStorage.removeItem(AMP_VEHICLE_REGISTRATION_KEY);
      document.cookie = "selectedVehicle=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT";

      if (!location.pathname.startsWith("/collections")) return;

      const params = new URLSearchParams(window.location.search);
      if (params.has("filter.v.m.car.ids")) {
        params.delete("filter.v.m.car.ids");
        if (typeof FacetFiltersForm !== "undefined") {
          FacetFiltersForm.renderPage(params.toString(), null, true);
        }
      }
    });
  }

  function isHome() {
      const currentUrl = new URL(window.location.href);
      const _isHome =
        currentUrl.pathname === "/" ||
        currentUrl.pathname === "" ||
        /\/index(\.html)?\/?$/.test(currentUrl.pathname);
      return _isHome;
  }

});

// Keep existing collection-link enhancer
document.addEventListener("click", function (e) {
  const link = e.target.closest("a[href]");
  if (!link) return;
  if (link.matches("[data-amp-remove-vehicle-filter],[data-amp-clear-all-filters]")) return;
  if (link.closest(".amp-exact-vehicle-grid")) return;

  const href = link.getAttribute("href");
  if (!href.startsWith("/collections")) return;

  const url = new URL(href, window.location.origin);
  if (ampIsNonFitmentCollection(url.pathname)) return;
  const explicitFilterId = String(
    url.searchParams.get("filter.v.m.car.ids") || ""
  ).trim();

  if (explicitFilterId) {
    const exactDestination = ampExactCategoryRoute(url.pathname, explicitFilterId) || (/^\/collections\/vl_[a-z0-9-]+\/?$/.test(url.pathname) ? ampExactVehicleRoute(explicitFilterId) : "");
    if (exactDestination) { e.preventDefault(); window.location.href = exactDestination; return; }
    const engineOption = [...document.querySelectorAll("#select-engine option")].find(
      (option) => String(option.dataset.linkageTargetId || "") === explicitFilterId
    );

    if (engineOption?.value) {
      try {
        const selectedEngine = JSON.parse(engineOption.value);
        const makeSelect = document.getElementById("select-make");
        const modelSelect = document.getElementById("select-model");
        const selectMakeId = makeSelect?.value || selectedEngine.mfrId || "";
        const selectModelId =
          modelSelect?.value || selectedEngine.vehicleModelSeriesId || "";
        const makeName =
          selectedEngine.mfrName ||
          makeSelect?.selectedOptions?.[0]?.textContent?.trim() ||
          "";
        const modelName =
          selectedEngine.vehicleModelSeriesName ||
          modelSelect?.selectedOptions?.[0]?.textContent?.trim() ||
          selectedEngine.bodyStyle ||
          "";
        let existingVehicle = null;
        try {
          existingVehicle = JSON.parse(localStorage.getItem("vehicle") || "null");
        } catch (error) {
          existingVehicle = null;
        }
        const sameVehicleTarget =
          String(existingVehicle?.linkageTargetId || existingVehicle?.engineId || "") ===
          explicitFilterId;
        const vehicle = {
          ...(sameVehicleTarget ? existingVehicle : {}),
          mark: makeName || existingVehicle?.mark || "",
          mfrId: selectedEngine.mfrId || existingVehicle?.mfrId || "",
          vehicleModelSeriesName:
            selectedEngine.vehicleModelSeriesName ||
            existingVehicle?.vehicleModelSeriesName ||
            modelName ||
            "",
          vehicleModelSeriesId:
            selectedEngine.vehicleModelSeriesId ||
            existingVehicle?.vehicleModelSeriesId ||
            "",
          vehicleDescription:
            selectedEngine.description || existingVehicle?.vehicleDescription || "",
          bodyTypeOfVehicle:
            [selectedEngine.vehicleModelSeriesName || modelName || "", selectedEngine.description || ""]
              .filter(Boolean)
              .join(" / ") ||
            selectedEngine.bodyStyle ||
            existingVehicle?.bodyTypeOfVehicle ||
            "",
          engineOutputInHP:
            selectedEngine.capacityCC || existingVehicle?.engineOutputInHP || "",
          engineCapacityCC:
            selectedEngine.capacityCC || existingVehicle?.engineCapacityCC || "",
          fuel: selectedEngine.fuelType || existingVehicle?.fuel || "",
          mfrYear:
            String(selectedEngine.beginYearMonth || "").slice(0, 4) ||
            existingVehicle?.mfrYear ||
            "",
          linkageTargetId: selectedEngine.linkageTargetId || explicitFilterId,
        };

        if (!sameVehicleTarget) localStorage.removeItem(AMP_VEHICLE_REGISTRATION_KEY);
        ampRememberVehicleRegistration(vehicle);
        localStorage.setItem("vehicle", JSON.stringify(vehicle));

        let storedFilterIds = [];
        try {
          storedFilterIds = JSON.parse(localStorage.getItem("filterId") || "[]");
        } catch (error) {
          storedFilterIds = [];
        }
        if (!Array.isArray(storedFilterIds)) storedFilterIds = [];
        storedFilterIds = storedFilterIds.filter(
          (item) => String(item?.selectEngineId || "") !== explicitFilterId
        );
        storedFilterIds.push({
          selectMakeId: String(selectMakeId),
          selectModelId: String(selectModelId),
          selectEngineId: explicitFilterId,
        });
        localStorage.setItem("filterId", JSON.stringify(storedFilterIds));

        document.cookie =
          "selectedVehicle=" +
          encodeURIComponent(
            JSON.stringify({
              vehicleType: "VL",
              manufacturer: makeName,
              manufacturerId: "vl_" + ampNormaliseManufacturerHandle(makeName),
              model: modelName,
              modelId: String(selectModelId),
              engine: [
                selectedEngine.description || "",
                selectedEngine.horsePowerFrom
                  ? `${selectedEngine.horsePowerFrom}CH`
                  : "",
                selectedEngine.capacityCC ? `${selectedEngine.capacityCC}CC` : "",
              ]
                .filter(Boolean)
                .join(", "),
              engineId: explicitFilterId,
              registration: vehicle.registration || "",
            })
          ) +
          "; path=/; max-age=" +
          60 * 60 * 24 * 30;
      } catch (error) {
        console.warn("Failed to retain vehicle selection for collection link:", error);
      }
    }

    return;
  }

  let vehicle = null;
  try {
    vehicle = JSON.parse(localStorage.getItem("vehicle") || "null");
  } catch (error) {
    vehicle = null;
  }
  if (!vehicle?.linkageTargetId) return;

  const exactCategoryDestination = ampExactCategoryRoute(url.pathname, vehicle.linkageTargetId);
  if (exactCategoryDestination) { e.preventDefault(); window.location.href = exactCategoryDestination; return; }

  e.preventDefault();
  url.searchParams.set("filter.v.m.car.ids", vehicle.linkageTargetId);

  try {
    document.cookie =
      "selectedVehicle=" +
      encodeURIComponent(
        JSON.stringify({
          vehicleType: "VL",
          manufacturer: vehicle.mark || "",
          manufacturerId: "vl_" + ampNormaliseManufacturerHandle(vehicle.mark || ""),
          model: vehicle.bodyTypeOfVehicle || "",
          modelId: "",
          engine: `${vehicle.engineOutputInHP || ""}CC ${vehicle.fuel || ""}`.trim(),
          engineId: String(vehicle.linkageTargetId),
        })
      ) +
      "; path=/; max-age=" +
      60 * 60 * 24 * 30;
  } catch (err) {}

  window.location.href = url.toString();
}, true);
// On filtered collection pages, keep the collection banner and vehicle selector
// visible while hiding navigation blocks before the product grid.
(function () {
  var preGridClass = "amp-mobile-filtered-pre-grid";
  var syncQueued = false;

  function hasActiveCollectionFilter() {
    if (!new RegExp("^/collections/[^/]+/?$").test(window.location.pathname)) return false;

    return Array.from(new URLSearchParams(window.location.search).keys()).some(function (key) {
      return key.indexOf("filter.") === 0;
    });
  }

  function syncFilteredCollectionLayout() {
    syncQueued = false;

    document.querySelectorAll("." + preGridClass).forEach(function (element) {
      element.classList.remove(preGridClass);
    });

    var isFiltered = hasActiveCollectionFilter();
    document.documentElement.classList.toggle("amp-mobile-collection-filtered", isFiltered);
    if (!isFiltered) return;

    var productSection = document.querySelector(
      "#MainContent > .section-main-collection-product-grid"
    );
    if (!productSection) return;

    var element = productSection.previousElementSibling;
    while (element) {
      if (
        element.tagName !== "STYLE" &&
        element.tagName !== "LINK" &&
        !element.classList.contains("breadcrumb") &&
        !element.classList.contains("section-main-collection-banner") &&
        !element.querySelector(".container-parts")
      ) {
        element.classList.add(preGridClass);
      }
      element = element.previousElementSibling;
    }
  }

  function scheduleFilteredCollectionLayoutSync() {
    if (syncQueued) return;
    syncQueued = true;
    window.requestAnimationFrame(syncFilteredCollectionLayout);
  }

  function startFilteredCollectionLayoutSync() {
    syncFilteredCollectionLayout();

    var main = document.getElementById("MainContent");
    if (main) {
      new MutationObserver(scheduleFilteredCollectionLayoutSync).observe(main, {
        childList: true,
        subtree: true,
      });
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      startFilteredCollectionLayoutSync,
      { once: true }
    );
  } else {
    startFilteredCollectionLayoutSync();
  }

  window.addEventListener("popstate", scheduleFilteredCollectionLayoutSync);
  window.addEventListener("pageshow", scheduleFilteredCollectionLayoutSync);
})();

// Send an unambiguous brand, vehicle-make or part-category search straight to
// its canonical collection. The lookup uses Shopify's own lightweight
// predictive-search section and fails open to the normal search page.
(function ampCanonicalCollectionSearchRedirect() {
  const resultCache = new Map();
  const pendingForms = new WeakSet();
  const generatedHandlePattern = /^(?:oem[-_]|all$|frontpage$)/i;
  const excludedCollectionHandles = new Set(["p_damping"]);
  const vinPattern = /^[A-HJ-NPR-Z0-9]{17}$/i;
  const ambiguousVehicleQueries = new Set(["ac"]);

  function normaliseLabel(value) {
    return String(value || "")
      .normalize("NFKD")
      .replace(/[\u0300-\u036f]/g, "")
      .toLowerCase()
      .replace(/&/g, " and ")
      .replace(/[^a-z0-9]+/g, " ")
      .trim()
      .replace(/\s+/g, " ");
  }

  function singulariseWord(word) {
    if (
      word.length <= 3 ||
      word === "series" ||
      word === "chassis" ||
      /(?:ss|us|is)$/.test(word)
    ) {
      return word;
    }

    if (word.endsWith("ies")) return `${word.slice(0, -3)}y`;
    if (/(?:ches|shes|xes|zes)$/.test(word)) return word.slice(0, -2);
    if (word.endsWith("s")) return word.slice(0, -1);
    return word;
  }

  function singularKey(value) {
    const words = normaliseLabel(value).split(" ").filter(Boolean);
    return words.map(singulariseWord).join(" ");
  }

  function collectionDetails(item) {
    const anchor = item.querySelector("a[href]");
    const heading = item.querySelector(".predictive-search-item-heading");
    if (!anchor || !heading) return null;

    let url;
    try {
      url = new URL(anchor.getAttribute("href"), window.location.origin);
    } catch (error) {
      return null;
    }

    if (url.origin !== window.location.origin) return null;
    const parts = url.pathname.split("/").filter(Boolean);
    const collectionIndex = parts.lastIndexOf("collections");
    if (collectionIndex < 0 || collectionIndex !== parts.length - 2) return null;

    const handle = decodeURIComponent(parts[collectionIndex + 1] || "").toLowerCase();
    if (
      !handle ||
      generatedHandlePattern.test(handle) ||
      excludedCollectionHandles.has(handle)
    ) {
      return null;
    }

    return {
      handle,
      pathname: url.pathname,
      title: heading.textContent.trim(),
    };
  }

  function scoreCollection(candidate, query) {
    const queryKey = normaliseLabel(query);
    const titleKey = normaliseLabel(candidate.title);
    const handleKey = normaliseLabel(candidate.handle.replace(/_/g, "-"));
    const isPartCategory = /^p[_-]/.test(candidate.handle);
    const isVehicleMake = /^vl[_-]/.test(candidate.handle);
    const titleWithoutCarParts = titleKey.endsWith(" car parts")
      ? titleKey.slice(0, -" car parts".length).trim()
      : "";
    const vehicleHandleKey = isVehicleMake
      ? normaliseLabel(candidate.handle.replace(/^vl[_-]/, ""))
      : "";

    if (isVehicleMake && ambiguousVehicleQueries.has(queryKey)) return 0;
    if ((isPartCategory || isVehicleMake) && titleKey === queryKey) return 500;

    if (
      isVehicleMake &&
      titleWithoutCarParts === queryKey &&
      vehicleHandleKey === queryKey
    ) {
      return 480;
    }

    if (
      titleWithoutCarParts === queryKey &&
      handleKey === queryKey
    ) {
      return 470;
    }

    if (
      isPartCategory &&
      singularKey(titleKey) === singularKey(queryKey)
    ) {
      return 450;
    }

    if (titleKey === queryKey && handleKey === queryKey) return 400;
    return 0;
  }

  function selectCanonicalCollection(markup, query) {
    const documentResult = new DOMParser().parseFromString(markup, "text/html");
    const scored = Array.from(
      documentResult.querySelectorAll(".predictive-search-list-item-collection"),
    )
      .map(collectionDetails)
      .filter(Boolean)
      .map((candidate) => ({
        candidate,
        score: scoreCollection(candidate, query),
      }))
      .filter((entry) => entry.score > 0);

    if (!scored.length) return null;
    const highestScore = Math.max(...scored.map((entry) => entry.score));
    const bestByPath = new Map(
      scored
        .filter((entry) => entry.score === highestScore)
        .map((entry) => [entry.candidate.pathname, entry.candidate]),
    );

    return bestByPath.size === 1 ? Array.from(bestByPath.values())[0] : null;
  }

  function destinationForCollection(candidate) {
    const destination = new URL(candidate.pathname, window.location.origin);
    const vehicleIds = window.ampVehicleTargetsFromSavedState?.() || [];

    Array.from(new Set(vehicleIds)).forEach((vehicleId) => {
      destination.searchParams.append("filter.v.m.car.ids", vehicleId);
    });

    return `${destination.pathname}${destination.search}`;
  }

  function attachVehicleFilterToSearchForm(form) {
    const vehicleIds = window.ampVehicleTargetsFromSavedState?.() || [];
    form
      .querySelectorAll('input[name="filter.v.m.car.ids"][data-amp-search-vehicle-filter]')
      .forEach((input) => input.remove());

    Array.from(new Set(vehicleIds)).forEach((vehicleId) => {
      const input = document.createElement("input");
      input.type = "hidden";
      input.name = "filter.v.m.car.ids";
      input.value = vehicleId;
      input.dataset.ampSearchVehicleFilter = "true";
      form.appendChild(input);
    });
  }

  async function resolveCanonicalCollection(query) {
    const cacheKey = normaliseLabel(query);
    if (resultCache.has(cacheKey)) return resultCache.get(cacheKey);

    const lookup = (async () => {
      const endpoint = new URL(
        window.routes?.predictive_search_url || "/search/suggest",
        window.location.origin,
      );
      endpoint.searchParams.set("q", query);
      endpoint.searchParams.set("resources[type]", "collection");
      endpoint.searchParams.set("resources[limit]", "10");
      endpoint.searchParams.set("resources[limit_scope]", "each");
      endpoint.searchParams.set("section_id", "predictive-search");

      const controller = new AbortController();
      const timeout = window.setTimeout(() => controller.abort(), 900);

      try {
        const response = await fetch(endpoint.toString(), {
          credentials: "same-origin",
          headers: { Accept: "text/html" },
          signal: controller.signal,
        });
        if (!response.ok) throw new Error(`Collection search failed: ${response.status}`);
        return selectCanonicalCollection(await response.text(), query);
      } finally {
        window.clearTimeout(timeout);
      }
    })();

    resultCache.set(cacheKey, lookup);
    try {
      return await lookup;
    } catch (error) {
      resultCache.delete(cacheKey);
      throw error;
    }
  }

  function isShopSearchForm(form) {
    let action;
    let searchUrl;
    try {
      action = new URL(form.getAttribute("action") || window.location.href, window.location.origin);
      searchUrl = new URL(window.routes?.search_url || "/search", window.location.origin);
    } catch (error) {
      return false;
    }

    const trimTrailingSlash = (pathname) => pathname.replace(/\/$/, "") || "/";
    return (
      action.origin === searchUrl.origin &&
      trimTrailingSlash(action.pathname) === trimTrailingSlash(searchUrl.pathname)
    );
  }

  function submitNormally(form) {
    HTMLFormElement.prototype.submit.call(form);
  }

  document.addEventListener(
    "submit",
    (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement) || !isShopSearchForm(form)) return;
      if (pendingForms.has(form)) {
        event.preventDefault();
        return;
      }

      const queryInput = form.elements.namedItem("q");
      const query = String(queryInput?.value || "").normalize("NFKC").trim();
      if (!query) return;

      const predictiveSearch = form.closest("predictive-search");
      if (predictiveSearch?.querySelector('[aria-selected="true"] a[href]')) return;

      const selectedSearchFilter = form.elements.namedItem("search-filter");
      if (String(selectedSearchFilter?.value || "").trim()) return;

      const compactQuery = query.replace(/[\s-]+/g, "").toUpperCase();
      if (
        window.ampDetectRegistrationCandidate?.(query) ||
        vinPattern.test(compactQuery)
      ) {
        return;
      }

      attachVehicleFilterToSearchForm(form);

      event.preventDefault();
      pendingForms.add(form);

      resolveCanonicalCollection(query)
        .then((candidate) => {
          if (candidate) {
            window.location.assign(destinationForCollection(candidate));
            return;
          }
          submitNormally(form);
        })
        .catch(() => submitNormally(form))
        .finally(() => pendingForms.delete(form));
    },
    true,
  );
})();

// Ask zero-result search customers whether a registration-shaped query should
// use the existing vehicle lookup. Detection and prompting never call the API.
(function ampRegistrationSearchPrompt() {
  const dismissedKey = "amp_registration_search_dismissed_v1";
  const dismissedLifetime = 30 * 60 * 1000;
  const currentFirstLetters = "[ABCDEFGHJKLMNOPRSTUVWXY]";
  const currentLastLetters = "[ABCDEFGHJKLMNOPRSTUVWXYZ]";
  const historicAgeLetter = "[ABCDEFGHJKLMNPRSTVWXY]";
  const historicSerialLetters = "[ABCDEFGHJKLMNOPRSTUVWXY]";

  function isIssuedCurrentAgeCode(value, now) {
    const code = Number(value);
    const year = now.getFullYear() % 100;
    const month = now.getMonth();

    if (code >= 2 && code <= year) {
      return code < year || month >= 2;
    }

    const septemberCode = 50 + year;
    if (code >= 51 && code <= septemberCode) {
      return code < septemberCode || month >= 8;
    }

    return false;
  }

  function detectRegistrationCandidate(rawValue, now = new Date()) {
    const source = String(rawValue || "").normalize("NFKC").trim();
    if (!source || !/^[A-Za-z0-9]+(?:[ \t]+[A-Za-z0-9]+)*$/.test(source)) {
      return null;
    }

    const compact = source.toUpperCase().replace(/[ \t]+/g, "");
    if (compact.length < 5 || compact.length > 7) return null;

    let match = compact.match(
      new RegExp(
        `^(${currentFirstLetters}{2}\\d{2})(${currentLastLetters}{3})$`
      )
    );
    if (match && isIssuedCurrentAgeCode(match[1].slice(-2), now)) {
      return {
        compact,
        display: `${match[1]} ${match[2]}`,
        style: "current",
      };
    }

    match = compact.match(
      new RegExp(
        `^(${historicAgeLetter}[1-9]\\d{0,2})(${historicSerialLetters}{3})$`
      )
    );
    if (match) {
      return {
        compact,
        display: `${match[1]} ${match[2]}`,
        style: "prefix",
      };
    }

    match = compact.match(
      new RegExp(
        `^(${historicSerialLetters}{3})([1-9]\\d{0,2}${historicAgeLetter})$`
      )
    );
    if (match) {
      return {
        compact,
        display: `${match[1]} ${match[2]}`,
        style: "suffix",
      };
    }

    return null;
  }

  window.ampDetectRegistrationCandidate = detectRegistrationCandidate;

  function rememberDismissed(registration) {
    try {
      sessionStorage.setItem(
        dismissedKey,
        JSON.stringify({ registration, dismissedAt: Date.now() })
      );
    } catch (error) {}
  }

  function wasRecentlyDismissed(registration) {
    try {
      const value = JSON.parse(sessionStorage.getItem(dismissedKey) || "null");
      return Boolean(
        value &&
          value.registration === registration &&
          Date.now() - Number(value.dismissedAt || 0) < dismissedLifetime
      );
    } catch (error) {
      return false;
    }
  }

  function clearDismissed() {
    try {
      sessionStorage.removeItem(dismissedKey);
    } catch (error) {}
  }

  function openRegistrationChoice(candidate) {
    if (document.querySelector(".amp-registration-search-dialog")) return;

    const dialog = document.createElement("dialog");
    dialog.className = "amp-registration-search-dialog";
    dialog.setAttribute("aria-labelledby", "amp-registration-search-title");
    dialog.setAttribute("aria-describedby", "amp-registration-search-description");
    dialog.innerHTML = `
      <div class="amp-registration-search-dialog-inner">
        <h2 id="amp-registration-search-title">Is this a vehicle registration?</h2>
        <div class="amp-registration-search-plate" aria-label="Registration"></div>
        <p id="amp-registration-search-description">
          Use it to find parts compatible with your vehicle, or keep searching
          the shop for this text. We only run the vehicle lookup if you choose Yes.
        </p>
        <p class="amp-registration-search-error" role="alert" hidden></p>
        <div class="amp-registration-search-actions">
          <button type="button" class="amp-registration-search-no">
            No, search products
          </button>
          <button type="button" class="amp-registration-search-yes">
            Yes, use registration
          </button>
        </div>
      </div>
    `;

    const plate = dialog.querySelector(".amp-registration-search-plate");
    const errorMessage = dialog.querySelector(".amp-registration-search-error");
    const noButton = dialog.querySelector(".amp-registration-search-no");
    const yesButton = dialog.querySelector(".amp-registration-search-yes");
    plate.textContent = candidate.display;
    window.ampTrackVehicleLookupAnalytics?.("search_prompt_shown", {
      method: "registration",
      source: "store_search_confirmation",
    });

    function closeDialog() {
      if (dialog.open && typeof dialog.close === "function") {
        dialog.close();
      } else {
        dialog.remove();
      }
    }

    noButton.addEventListener("click", () => {
      window.ampTrackVehicleLookupAnalytics?.("search_prompt_no", {
        method: "registration",
        source: "store_search_confirmation",
      });
      rememberDismissed(candidate.compact);
      closeDialog();
    });

    yesButton.addEventListener("click", async () => {
      yesButton.disabled = true;
      noButton.disabled = true;
      dialog.classList.add("is-loading");
      clearDismissed();
      errorMessage.hidden = true;
      errorMessage.textContent = "";
      window.ampTrackVehicleLookupAnalytics?.("search_prompt_yes", {
        method: "registration",
        source: "store_search_confirmation",
      });

      const lookup = window.ampRunRegistrationLookup;
      const result =
        typeof lookup === "function"
          ? await lookup(candidate.compact, {
              challengeAnchor: yesButton,
              analyticsSource: "store_search_confirmation",
            })
          : {
              ok: false,
              message: "The vehicle lookup is temporarily unavailable. Please try again.",
            };
      if (result?.ok) return;

      dialog.classList.remove("is-loading");
      yesButton.disabled = false;
      noButton.disabled = false;
      errorMessage.textContent =
        result?.message || "The vehicle lookup is temporarily unavailable. Please try again.";
      errorMessage.hidden = false;
      yesButton.focus();
    });

    dialog.addEventListener("cancel", (event) => {
      event.preventDefault();
      rememberDismissed(candidate.compact);
      closeDialog();
    });
    dialog.addEventListener("click", (event) => {
      if (event.target !== dialog) return;
      rememberDismissed(candidate.compact);
      closeDialog();
    });
    dialog.addEventListener("close", () => dialog.remove(), { once: true });

    document.body.appendChild(dialog);
    if (typeof dialog.showModal === "function") {
      dialog.showModal();
    } else {
      dialog.setAttribute("open", "");
    }
    window.requestAnimationFrame(() => noButton.focus());
  }

  function promptOnEmptySearch() {
    if (window.location.pathname !== "/search") return;
    if (!document.querySelector(".template-search-empty")) return;

    const query = new URLSearchParams(window.location.search).get("q") || "";
    const candidate = detectRegistrationCandidate(query);
    if (!candidate) return;
    window.ampTrackVehicleLookupAnalytics?.("search_detected", {
      method: "registration",
      source: "store_search_confirmation",
    });
    if (wasRecentlyDismissed(candidate.compact)) return;
    openRegistrationChoice(candidate);
  }

  function initialiseRegistrationSearchPrompt() {
    promptOnEmptySearch();
  }

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      initialiseRegistrationSearchPrompt,
      { once: true }
    );
  } else {
    initialiseRegistrationSearchPrompt();
  }
})();
